import type React from 'react';

import { FormGroup } from '../../templates/form-group/form-group';
import type { TextAreaProps } from './text-area.types';

export function TextArea({
  label,
  helpText,
  errorText,
  disabled,
  error,
  name,
  id,
  ...textAreaProps
}: React.TextareaHTMLAttributes<HTMLTextAreaElement> & TextAreaProps) {
  const showErrors = error;
  const inputId = id || name;

  return (
    <FormGroup disabled={disabled} error={showErrors}>
      <label className="hc-label" htmlFor={inputId}>
        {label}
      </label>
      <div className="hc-form-control hc-textarea__container">
        <textarea
          {...textAreaProps}
          disabled={disabled}
          name={name}
          id={inputId}
        />
      </div>
      <span className="hc-help-text"> {helpText}</span>
      <span className="hc-error-text">{errorText}</span>
    </FormGroup>
  );
}
